import { PureComponent } from "react";
import { connect } from "react-redux";
import WidgetJSLoader from "./WidgetJSLoader";
import Loading from "Components/Loading";
import ErrorBoundary from "Components/ErrorBoundary";
import { getLanguageMetas, getCurrentLangIndex } from "Pub/js/getMulti";
import { getScale } from '../../NewHome/utilService';
/**
 * 通过 js 片段创建小部件
 */
class WidgetForJS extends PureComponent {
    constructor(props) {
        super(props);
        this.state = {
            widget: null,
            multiLangInfo: {
                langIndex: getCurrentLangIndex(),
                languageMetas: getLanguageMetas()
            } 
        };
    }
    componentDidMount() {
        WidgetJSLoader(this.props.src, key => {
            this.setState({
                widget: window[key].default
            }, () => {
                this.props.onWidgetMounted();
            });
        });
    }
    render() {
        const { multiLangInfo } = this.state;
        let WidgetCom = this.state.widget;
        const {
            appcode,
            width,
            height,
            item: appOption,
            linkRelation,
            cardId,
            editable,
            onSideChange,
            onMaskToggle,
            relateidObj,
            workbenchId,
            generateNumberName,
            renderLinkageIcons = () => { return null },
            renderEditCustomArea = () => {},
            isPublished,
            renderHeaderCustomArea,
        } = this.props;
        const themeColor = this.props.themeColor || window.nccColor; //主题色传给部件
        let RenderCom =
            typeof WidgetCom === "function" ? (
                // 将appOption传给小部件，可能用到里边的信息（快速发起小部件内有配置标题，图标，背景色等）
                <WidgetCom
                    id={cardId}
                    appcode={appcode}
                    widgetWidth={width}
                    widgetHeight={height}
                    themeColor={themeColor}
                    appOption={appOption}
                    linkRelation={linkRelation}
                    renderLinkageIcons={renderLinkageIcons}
                    sideData={appOption.sideData || {}}
                    editable={editable}
                    partType={appOption.parttype}
                    onChange={(sideData) => {
                        onSideChange && onSideChange(sideData);
                    }}
                    onMaskToggle={onMaskToggle}
                    editEntry={{ // 桌面配置入口
                        isWorkbench: relateidObj.type === 'workbench'
                    }}
                    workbenchId={workbenchId}
                    multiLangInfo={multiLangInfo}
                    generateNumberName={generateNumberName}
                    scale={getScale()}
                    renderEditCustomArea={renderEditCustomArea}
                    isPublished={isPublished}
                    renderHeaderCustomArea={renderHeaderCustomArea}
                    getPopupContainer={() => document.querySelector('.nc-workbench-container')}
                />
            ) : (
                <Loading style={{ width: "100%", height: "100%" }} />
            );
        let { groupId, name } = this.props;
        return (
            <ErrorBoundary>
                <div
                    style={{ overflow: "auto" }}
                    id={`${groupId}_${cardId}`}
                    className="app-item"
                    fieldid={`${name}_app-item`}
                >
                    {RenderCom}
                </div>
            </ErrorBoundary>
        );
    }
}
export default connect(
    state => ({
        themeColor: state.appData.themeColor,
        workbenchId: state.appData.workbenchId
    })
)(WidgetForJS);
